export const APP_SHELL_STYLES = `
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800;900&display=swap');
*,*::before,*::after{box-sizing:border-box;margin:0;padding:0}
body{background:#1F4754;font-family:'Inter',sans-serif}
.r{background:linear-gradient(160deg,#1F4754 0%,#2A5868 50%,#3A7080 100%);min-height:100vh;font-family:'Inter',sans-serif;-webkit-font-smoothing:antialiased;padding-bottom:60px}

/* TOPBAR */
.r .tb{background:rgba(25,58,68,0.95);padding:8px 0;position:sticky;top:0;z-index:200;backdrop-filter:blur(12px);border-bottom:1px solid rgba(255,255,255,0.07)}
.r .tbi{max-width:1100px;margin:0 auto;padding:0 14px;display:flex;align-items:center;justify-content:space-between;gap:8px;flex-wrap:wrap}
.r .logo{cursor:pointer;display:flex;align-items:center;gap:6px;flex-shrink:0}
.r .ln{font-size:15px;font-weight:900;color:#FFF;letter-spacing:-0.02em}
.r .ls{font-size:8px;font-weight:600;color:rgba(255,255,255,0.5);letter-spacing:0.22em;text-transform:uppercase}
.r nav{display:flex;gap:2px;overflow-x:auto;-webkit-overflow-scrolling:touch;flex-wrap:nowrap}
.r nav button{background:transparent;border:none;color:rgba(255,255,255,0.6);font-size:11px;font-weight:600;padding:6px 10px;cursor:pointer;font-family:inherit;border-radius:7px;white-space:nowrap;flex-shrink:0}
.r nav button.a{color:#FFF;background:rgba(255,255,255,0.13)}
.r nav button:hover{color:#FFF}
.r .ub{display:flex;align-items:center;gap:7px;padding:3px 10px 3px 3px;background:rgba(255,255,255,0.09);border-radius:999px;border:1px solid rgba(255,255,255,0.12);flex-shrink:0}
.r .ua{width:26px;height:26px;border-radius:50%;background:#4FB3A9;color:#FFF;display:grid;place-items:center;font-weight:700;font-size:12px;background-size:cover;background-position:center}
.r .un{font-size:11px;font-weight:700;color:#FFF;line-height:1.1}
.r .uc{font-size:9px;color:rgba(255,255,255,0.5)}
.r .nb{background:#D9534F;color:#FFF;border-radius:999px;padding:0 5px;font-size:9px;font-weight:800;margin-left:2px}

/* CONTAINERS */
.r .ct{max-width:1100px;margin:0 auto;padding:14px}
.r .cn{max-width:580px;margin:0 auto;padding:14px}
.r .pt{font-size:22px;font-weight:800;color:#FFF;margin-bottom:3px;line-height:1.2;text-align:center;letter-spacing:-0.01em}
.r .pt em{font-style:normal;color:#FFC76B}
.r .ps{font-size:12px;color:rgba(255,255,255,0.6);text-align:center;margin-bottom:14px}

/* CARDS */
.r .card{background:#FFF;border-radius:14px;overflow:hidden;box-shadow:0 2px 12px rgba(0,0,0,0.1)}
.r .ch{padding:12px 14px 10px;display:flex;align-items:center;gap:10px}
.r .ca{width:38px;height:38px;border-radius:50%;background:#1F4754;color:#FFF;display:grid;place-items:center;font-weight:700;font-size:14px;flex-shrink:0;background-size:cover;background-position:center;cursor:pointer}
.r .cw{flex:1;min-width:0}
.r .cn2{font-size:13.5px;font-weight:700;color:#1F4754;cursor:pointer}
.r .cn2:hover{color:#4FB3A9}
.r .cm{font-size:11px;color:#6B8590;margin-top:2px}
.r .ct2{font-size:9px;font-weight:700;letter-spacing:0.06em;text-transform:uppercase;padding:4px 9px;border-radius:999px;color:#FFF;flex-shrink:0}
.r .cb{padding:12px 14px}
.r .ck{padding:10px 14px;border-top:1px solid #F0F4F6;display:flex;align-items:center;justify-content:space-between}

/* ATIVIDADES */
.r .al{display:flex;flex-direction:column;gap:5px}
.r .ai{display:flex;align-items:center;justify-content:space-between;padding:9px 11px;background:#F4F8F9;border-radius:9px;border-left:3px solid #4FB3A9}
.r .ail{font-size:13px;font-weight:600;color:#1F4754}
.r .aiq{font-size:11px;color:#6B8590;margin-top:1px}
.r .aip{text-align:right;line-height:1}
.r .aip .rank{font-size:14px;font-weight:800;color:#FF8C42}
.r .aip .tok{font-size:12px;font-weight:700;color:#4FB3A9}
.r .aip small{font-size:8px;letter-spacing:.12em;color:#6B8590;display:block;text-transform:uppercase;font-weight:600}
.r .obs{padding:10px 12px;background:#F4F8F9;border-radius:9px;font-size:13px;color:#2A5868;margin-top:10px;line-height:1.45;font-style:italic;border-left:3px solid #E0E8EB}

/* BOTOES */
.r .btn{display:inline-flex;align-items:center;justify-content:center;gap:7px;padding:11px 20px;font-family:'Inter',sans-serif;font-size:13.5px;font-weight:700;border-radius:10px;border:none;background:#4FB3A9;color:#FFF;cursor:pointer;transition:all .15s;box-shadow:0 1px 4px rgba(79,179,169,0.3)}
.r .btn:hover{background:#3D9A91}
.r .btn:active{transform:scale(0.98)}
.r .btn:disabled{opacity:0.45;cursor:not-allowed}
.r .bo{background:transparent;color:#FFF;border:1.5px solid rgba(255,255,255,0.35);box-shadow:none}
.r .bo:hover{background:rgba(255,255,255,0.1);border-color:#FFF}
.r .bg{background:transparent;color:#6B8590;border:1px solid #D5DEE3;box-shadow:none}
.r .bg:hover{background:#F4F8F9;color:#1F4754}
.r .bd{background:transparent;color:#D9534F;border:1.5px solid #D9534F;box-shadow:none}
.r .bd:hover{background:#D9534F;color:#FFF}
.r .bor{background:#FF8C42;box-shadow:0 1px 4px rgba(255,140,66,0.3)}
.r .bor:hover{background:#E07B35}
.r .bs{padding:7px 12px;font-size:11.5px;border-radius:8px}
.r .bb{width:100%}

/* FORMS */
.r .fc{background:#FFF;border-radius:14px;padding:18px 15px;box-shadow:0 2px 12px rgba(0,0,0,0.09)}
.r .fr{display:flex;gap:10px}
.r .fr>*{flex:1;min-width:0}
.r .fg{margin-bottom:12px}
.r .fg label{display:block;font-size:12px;font-weight:700;color:#1F4754;margin-bottom:5px}
.r .inp,.r .sel,.r .tea{width:100%;padding:11px 13px;background:#FFF;border:1.5px solid #D5DEE3;border-radius:9px;color:#1F4754;font-family:'Inter',sans-serif;font-size:14.5px;font-weight:500;transition:border-color .15s;-webkit-appearance:none;appearance:none}
.r .sel{background-image:url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%231F4754' stroke-width='2'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e");background-repeat:no-repeat;background-position:right 11px center;background-size:15px;padding-right:34px}
.r .inp:focus,.r .sel:focus,.r .tea:focus{outline:none;border-color:#4FB3A9}
.r .tea{resize:vertical;min-height:70px;font-family:inherit}
.r input[type=color]{height:42px;padding:4px;cursor:pointer}
.r input[type=file]{padding:8px;cursor:pointer;font-size:12px}
.r input[type=checkbox]{width:17px;height:17px;accent-color:#4FB3A9;cursor:pointer}

/* BUSCA (autocomplete) */
.r .busca-wrap{position:relative}
.r .busca-lista{position:absolute;top:100%;left:0;right:0;background:#FFF;border:1.5px solid #4FB3A9;border-top:none;border-radius:0 0 9px 9px;z-index:50;max-height:200px;overflow-y:auto;box-shadow:0 4px 12px rgba(0,0,0,0.1)}
.r .busca-item{padding:10px 13px;cursor:pointer;font-size:13px;color:#1F4754;display:flex;align-items:center;gap:8px;border-bottom:1px solid #F4F8F9}
.r .busca-item:hover{background:#F4F8F9}
.r .busca-item:last-child{border-bottom:none}

/* FILTROS / TABS */
.r .fi{display:flex;flex-wrap:wrap;gap:5px;align-items:center;margin-bottom:12px;padding:9px 11px;background:rgba(255,255,255,0.96);border-radius:11px;box-shadow:0 2px 8px rgba(0,0,0,0.07)}
.r .fl{font-size:10px;color:#6B8590;font-weight:700;padding:0 3px;white-space:nowrap}
.r .fi .sel{width:auto;padding:6px 26px 6px 10px;font-size:12px;background-color:#F4F8F9;border-color:#E0E8EB}
.r .tabs{display:flex;background:rgba(255,255,255,0.1);padding:3px;border-radius:11px;margin-bottom:14px;gap:3px;flex-wrap:wrap}
.r .tabs button{flex:1;background:transparent;border:none;padding:9px 6px;color:rgba(255,255,255,0.6);font-size:11.5px;font-weight:700;cursor:pointer;font-family:inherit;border-radius:8px;white-space:nowrap;min-width:60px}
.r .tabs button.a{color:#1F4754;background:#FFF}

/* RANKING */
.r .rl{display:flex;flex-direction:column;gap:6px}
.r .ri{display:flex;align-items:center;gap:10px;padding:11px 12px;background:#FFF;border-radius:11px;cursor:pointer;box-shadow:0 1px 4px rgba(0,0,0,0.07)}
.r .ri:active{transform:scale(0.99)}
.r .ri.t1{background:linear-gradient(90deg,#FFF4E0,#FFF 60%);border:1.5px solid #FFC76B}
.r .rp{font-size:20px;font-weight:900;color:#B8C5CC;min-width:34px;text-align:center}
.r .ri.t1 .rp{color:#FF8C42}
.r .ri.t2 .rp{color:#8A99A2}
.r .ri.t3 .rp{color:#C99878}
.r .rav{width:38px;height:38px;border-radius:50%;background:#1F4754;color:#FFF;display:grid;place-items:center;font-weight:700;flex-shrink:0;background-size:cover;background-position:center;font-size:13px}
.r .rin{flex:1;min-width:0}
.r .rin .nm{font-size:13.5px;font-weight:700;color:#1F4754}
.r .rin .mt{font-size:11px;color:#6B8590;margin-top:2px}
.r .rv{font-size:19px;font-weight:800;color:#FF8C42;text-align:right;line-height:1}
.r .rv small{display:block;font-size:9px;color:#6B8590;text-transform:uppercase;margin-top:3px;font-weight:600}

/* CASAS */
.r .cr{display:grid;grid-template-columns:repeat(auto-fit,minmax(140px,1fr));gap:9px;margin-bottom:14px}
.r .cc{background:#FFF;border-radius:13px;padding:14px 12px;position:relative;box-shadow:0 2px 8px rgba(0,0,0,0.08);border-top:4px solid;transition:transform .15s}
.r .cc:hover{transform:translateY(-2px)}
.r .cc-img{width:100%;height:70px;object-fit:cover;border-radius:8px;margin-bottom:7px}
.r .cnm{font-size:14px;font-weight:700;color:#1F4754}
.r .cv{font-size:26px;font-weight:800;margin-top:6px;color:#FF8C42}
.r .cmt{font-size:11px;color:#6B8590;margin-top:3px;font-weight:600}
.r .cp{position:absolute;top:9px;right:12px;font-size:16px;font-weight:800;color:#B8C5CC}
.r .cc.t1 .cp{color:#FF8C42}

/* TABELA */
.r .tbl{width:100%;background:#FFF;border-radius:11px;border-collapse:separate;border-spacing:0;overflow:hidden;box-shadow:0 2px 8px rgba(0,0,0,0.07)}
.r .tbl th,.r .tbl td{padding:10px 12px;text-align:left;font-size:12.5px;border-bottom:1px solid #F0F4F6;color:#1F4754}
.r .tbl th{background:#F4F8F9;font-size:10px;font-weight:700;color:#6B8590;text-transform:uppercase;letter-spacing:0.05em}
.r .tbl tr:last-child td{border-bottom:none}
.r .tbl tr:hover td{background:#FAFCFD}

/* FLASH */
.r .fl2{padding:11px 14px;border-radius:9px;margin-bottom:12px;font-size:13px;font-weight:500}
.r .ok{background:#E0F5F0;color:#1A7A6E;border-left:4px solid #4FB3A9}
.r .er{background:#FFE5E0;color:#B83A2E;border-left:4px solid #D9534F}
.r .in{background:#FFF1DD;color:#B8651E;border-left:4px solid #FF8C42}
.r .wa{background:#EEF2FF;color:#3730A3;border-left:4px solid #6366F1}

/* EMPTY */
.r .es{text-align:center;padding:30px 14px;background:rgba(255,255,255,0.07);border-radius:14px}
.r .es h3{font-size:15px;font-weight:700;color:#FFF;margin-bottom:4px}
.r .es p{color:rgba(255,255,255,0.65);font-size:13px}

/* LOGIN */
.r .lw{min-height:78vh;display:grid;place-items:center;padding:14px}
.r .lc{width:100%;max-width:390px;background:#FFF;border-radius:16px;padding:28px 20px;text-align:center;box-shadow:0 8px 24px rgba(0,0,0,0.18)}
.r .lc h2{font-size:21px;font-weight:800;color:#1F4754;margin-bottom:3px}
.r .lc .sub{font-size:10px;font-weight:700;letter-spacing:0.2em;text-transform:uppercase;color:#6B8590;margin-bottom:18px}

/* STATS */
.r .sg{display:grid;grid-template-columns:repeat(2,1fr);gap:8px;margin-bottom:14px}
.r .sc{background:#FFF;border-radius:12px;padding:13px 12px;box-shadow:0 2px 8px rgba(0,0,0,0.07)}
.r .sl{font-size:9px;color:#6B8590;font-weight:700;text-transform:uppercase;letter-spacing:0.05em}
.r .sv{font-size:22px;color:#1F4754;margin-top:4px;font-weight:800}

/* PERFIL */
.r .ph{background:#FFF;border-radius:14px;padding:18px 15px;display:flex;align-items:center;gap:13px;margin-bottom:14px;box-shadow:0 2px 12px rgba(0,0,0,0.08)}
.r .pa{width:72px;height:72px;border-radius:50%;background:#1F4754;color:#FFF;display:grid;place-items:center;font-weight:700;font-size:26px;flex-shrink:0;background-size:cover;background-position:center;border:3px solid #FFF;box-shadow:0 2px 8px rgba(0,0,0,0.15)}
.r .pn{font-size:20px;font-weight:800;color:#1F4754;line-height:1.1;letter-spacing:-0.01em}
.r .pm{color:#6B8590;font-size:12px;margin-top:6px;display:flex;gap:8px;flex-wrap:wrap}
.r .po{display:inline-block;margin-top:8px;padding:4px 11px;background:#FFF1DD;border-radius:999px;color:#B8651E;font-size:11px;font-weight:700}

/* MERITOS */
.r .meritos-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(130px,1fr));gap:8px}
.r .merito-card{background:#FFF;border-radius:12px;padding:13px 11px;text-align:center;box-shadow:0 2px 8px rgba(0,0,0,0.07);transition:transform .15s;position:relative;overflow:hidden}
.r .merito-card.off{opacity:0.45;filter:grayscale(0.6)}
.r .merito-card:hover{transform:translateY(-2px)}
.r .merito-icone{font-size:28px;margin-bottom:6px}
.r .merito-titulo{font-size:12px;font-weight:700;color:#1F4754;line-height:1.2}
.r .merito-desc{font-size:10px;color:#6B8590;margin-top:3px;line-height:1.3}
.r .merito-prog{height:4px;background:#F0F4F6;border-radius:999px;margin-top:8px;overflow:hidden}
.r .merito-prog-fill{height:4px;background:#4FB3A9;border-radius:999px;transition:width .3s}
.r .merito-card.conquistado .merito-prog-fill{background:#FFC76B}
.r .merito-pct{font-size:9px;color:#6B8590;margin-top:3px;font-weight:700}
.r .insignia-mini{display:inline-flex;align-items:center;gap:3px;background:#FFF1DD;border-radius:999px;padding:2px 7px;font-size:9.5px;font-weight:700;color:#B8651E}

/* LOJA */
.r .loja-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(150px,1fr));gap:10px}
.r .loja-item{background:#FFF;border-radius:13px;padding:14px;box-shadow:0 2px 10px rgba(0,0,0,0.08);display:flex;flex-direction:column;gap:6px;border:2px solid transparent}
.r .loja-item.pode{border-color:rgba(79,179,169,0.35)}
.r .loja-nome{font-size:13px;font-weight:700;color:#1F4754}
.r .loja-desc{font-size:11px;color:#6B8590;line-height:1.35}
.r .loja-custo{font-size:16px;font-weight:800;color:#4FB3A9}
.r .loja-est{font-size:10px;color:#6B8590;font-weight:600}

/* DESAFIOS */
.r .desafio-card{background:#FFF;border-radius:13px;padding:14px;box-shadow:0 2px 10px rgba(0,0,0,0.08);margin-bottom:10px}
.r .placar{display:flex;gap:6px;align-items:center;background:rgba(31,71,84,0.07);border-radius:10px;padding:10px;margin:10px 0}
.r .placar-lado{flex:1;text-align:center;border-radius:8px;padding:8px 4px}
.r .placar-nome{font-size:11px;color:#6B8590;margin-bottom:3px;font-weight:600}
.r .placar-val{font-size:22px;font-weight:800;line-height:1}

/* DIVISOR */
.r .dv{display:flex;align-items:center;gap:11px;margin:16px 0}
.r .dv::before,.r .dv::after{content:'';flex:1;height:1px;background:#D5DEE3}
.r .dv span{font-size:10px;color:#6B8590;font-weight:700;text-transform:uppercase;letter-spacing:0.1em;white-space:nowrap}
.r .dv-dark::before,.r .dv-dark::after{background:rgba(255,255,255,0.18)}
.r .dv-dark span{color:rgba(255,255,255,0.8)}

/* ADMIN */
.r .ga{display:grid;grid-template-columns:1fr;gap:14px}
@media(min-width:900px){.r .ga{grid-template-columns:1fr 310px}}
.r .bst{font-size:9px;padding:3px 8px;border-radius:999px;font-weight:700;text-transform:uppercase}
.r .bon{background:#E0F5F0;color:#1A7A6E}
.r .bof{background:#F0F4F6;color:#6B8590}

/* BANNER */
.r .bnr{background:rgba(0,0,0,0.35);color:#FFF;padding:5px 12px;text-align:center;font-size:10px}
.r .bnr strong{color:#FFC76B;font-weight:700}
.r .bnr code{background:rgba(255,255,255,0.12);padding:1px 6px;border-radius:4px;font-size:10px}

/* MOEDAS */
.r .moeda-rank{color:#FF8C42;font-weight:800}
.r .moeda-tok{color:#4FB3A9;font-weight:800}

/* SIDEBAR */
.r .sidebar{transform:translateX(-100%);visibility:hidden;position:fixed;left:0;top:0;bottom:0;width:230px;background:#0F2A34;z-index:300;display:flex;flex-direction:column;border-right:1px solid rgba(255,255,255,0.07);transition:transform .22s ease;overflow:hidden}
.r .sidebar.open{transform:translateX(0);visibility:visible}
.r .sb-logo{padding:14px 16px 10px;border-bottom:1px solid rgba(255,255,255,0.07);flex-shrink:0}
.r .sb-logo-title{font-size:15px;font-weight:900;color:#FFF;letter-spacing:-0.02em}
.r .sb-logo-sub{font-size:8px;font-weight:600;color:rgba(255,255,255,0.35);letter-spacing:0.2em;text-transform:uppercase;margin-top:2px}
.r .sb-user{padding:10px 14px;border-bottom:1px solid rgba(255,255,255,0.07);display:flex;align-items:center;gap:9px;flex-shrink:0}
.r .sb-av{width:30px;height:30px;border-radius:50%;background:#4FB3A9;color:#FFF;display:grid;place-items:center;font-weight:700;font-size:12px;flex-shrink:0;background-size:cover;background-position:center}
.r .sb-name{font-size:12px;font-weight:700;color:#FFF;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
.r .sb-sub{font-size:10px;color:rgba(255,255,255,0.4);margin-top:1px}
/* NAV: ocupa o espaco mas nao estica os filhos */
.r .sb-nav{flex:1;display:flex;flex-direction:column;overflow-y:auto;overflow-x:hidden;padding:6px 0}
/* ITEM: altura fixa, nunca estica */
.r .sb-item{display:flex;align-items:center;gap:11px;height:40px;padding:0 16px;cursor:pointer;transition:background .1s;border:none;background:transparent;width:100%;text-align:left;font-family:inherit;color:rgba(255,255,255,0.65);font-size:13px;font-weight:600;white-space:nowrap;flex-shrink:0}
.r .sb-item:hover{background:rgba(255,255,255,0.07);color:#FFF}
.r .sb-item.active{background:rgba(79,179,169,0.14);color:#FFF;border-left:3px solid #4FB3A9;padding-left:13px}
.r .sb-item.active .sb-icon{color:#4FB3A9;opacity:1}
.r .sb-item.destaque{color:#FF8C42}
.r .sb-item.destaque:hover{background:rgba(255,140,66,0.1)}
.r .sb-item.destaque.active{border-left-color:#FF8C42}
.r .sb-icon{width:16px;height:16px;flex-shrink:0;opacity:0.6}
.r .sb-item:hover .sb-icon{opacity:1}
.r .sb-badge{background:#D9534F;color:#FFF;border-radius:999px;padding:1px 6px;font-size:9px;font-weight:800;margin-left:auto;flex-shrink:0}
.r .sb-section{font-size:9px;font-weight:700;color:rgba(255,255,255,0.2);text-transform:uppercase;letter-spacing:0.14em;padding:10px 16px 3px;flex-shrink:0}
.r .sb-footer{padding:10px 12px;border-top:1px solid rgba(255,255,255,0.07);flex-shrink:0}
.r .sb-sair{width:100%;background:transparent;border:1px solid rgba(255,255,255,0.1);color:rgba(255,255,255,0.4);border-radius:7px;padding:8px;font-size:12px;font-weight:600;cursor:pointer;font-family:inherit;transition:all .15s;display:flex;align-items:center;justify-content:center;gap:7px}
.r .sb-sair:hover{background:rgba(217,83,79,0.15);border-color:#D9534F;color:#D9534F}
/* TOPBAR MINIMALISTA (so quando logado) */
.r .tb-mini{background:rgba(18,46,56,0.95);padding:10px 16px;position:sticky;top:0;z-index:250;backdrop-filter:blur(12px);border-bottom:1px solid rgba(255,255,255,0.07);display:flex;align-items:center;gap:12px}
.r .tb-mini .logo-m{font-size:13px;font-weight:800;color:#FFF;letter-spacing:-0.01em;cursor:pointer}
.r .tb-menu-btn{background:transparent;border:none;color:rgba(255,255,255,0.7);cursor:pointer;padding:4px;display:flex;align-items:center;justify-content:center;border-radius:7px}
.r .tb-menu-btn:hover{background:rgba(255,255,255,0.1);color:#FFF}
/* TOPBAR PUBLICA (sem login) */
.r .tb{background:rgba(25,58,68,0.95);padding:8px 0;position:sticky;top:0;z-index:200;backdrop-filter:blur(12px);border-bottom:1px solid rgba(255,255,255,0.07)}
.r .tbi{max-width:1100px;margin:0 auto;padding:0 14px;display:flex;align-items:center;justify-content:space-between;gap:8px}
.r nav{display:flex;gap:2px}
.r nav button{background:transparent;border:none;color:rgba(255,255,255,0.6);font-size:11px;font-weight:600;padding:6px 10px;cursor:pointer;font-family:inherit;border-radius:7px;white-space:nowrap;flex-shrink:0}
.r nav button.a{color:#FFF;background:rgba(255,255,255,0.13)}
.r nav button:hover{color:#FFF}
/* OVERLAY */
.r .sb-overlay{position:fixed;inset:0;background:rgba(0,0,0,0.5);z-index:299;backdrop-filter:blur(2px)}
/* MAIN CONTENT deslocado */
.r .main-shifted{margin-left:0;min-height:100vh}
@media(max-width:600px){.r{--dm-lesson-gutter:4px}}
@media(min-width:1341px){.r .main-shifted.sidebar-expanded{margin-left:230px}.r .sb-overlay{display:none}}
/* SIDEBAR COLAPSADA PARA TABLETS */
@media(max-width:1340px){
  .r .sidebar{transform:translateX(-100%)}
  .r .sidebar.open{transform:translateX(0)}
  .r .main-shifted{margin-left:0}
}
/* RESPONSIVE */
@media(max-width:768px){
  .r .sidebar{transform:translateX(-100%)}
  .r .sidebar.open{transform:translateX(0)}
  .r .main-shifted{margin-left:0}
  .r .tbi{padding:0 10px}
  .r .ct,.r .cn{padding:10px 11px}
  .r .pt{font-size:19px}
  .r .fc{padding:15px 12px}
  .r .fr{flex-direction:column;gap:0}
  .r .ph{flex-direction:column;text-align:center}
  .r .pm{justify-content:center}
  .r .sg{gap:6px}
  .r .sv{font-size:20px}
  .r .loja-grid{grid-template-columns:1fr 1fr}
  .r .cr{grid-template-columns:1fr 1fr}
  .r .btn{padding:10px 15px;font-size:13px}
  .r .bs{padding:6px 10px;font-size:11px}
  .r .tabs button{font-size:10.5px;padding:8px 5px}
  .r .meritos-grid{grid-template-columns:repeat(auto-fill,minmax(110px,1fr))}
}

.r .sidebar{background:#122f35;border-right:1px solid #ffffff0c;border-radius:0 20px 20px 0;box-shadow:10px 0 32px #102e3615}.r .sb-logo{padding:25px 22px 20px;border-bottom:0}.r .sb-logo-title{font-size:20px;font-weight:800;letter-spacing:-.7px;color:#e9f6f2}.r .sb-logo-sub{font-size:8px;letter-spacing:2.3px;font-weight:500;color:#a4bcb6;margin-top:7px}.r .sb-user{padding:16px 22px;gap:12px;border-top:1px solid #ffffff0c;border-bottom:1px solid #ffffff0c}.r .sb-av{width:37px;height:37px;font-size:15px;background:#acd7c5!important;color:#163b35}.r .sb-name{font-size:13px;color:#e9f6f2}.r .sb-sub{font-size:10px;color:#93ada6;margin-top:4px}.r .sb-nav{min-height:0;padding:10px 12px 12px;scrollbar-width:thin;scrollbar-color:#446962 transparent}.r .sb-section{padding:10px 12px 10px;font-size:9px;letter-spacing:1.8px;font-weight:600;color:#7d9990}.r .sb-item{width:100%;height:37px;min-height:37px;margin:2px 0;padding:0 13px;gap:0;border-radius:10px;color:#b6ccc7;font-size:13px;font-weight:500;transition:background .15s,color .15s}.r .sb-item:hover{background:#ffffff0a;color:#e9f6f2}.r .sb-item.active,.r .sb-item.destaque.active{background:#bedfce;color:#143d34;border-left:0;padding-left:13px;font-weight:800}.r .sb-item.destaque{color:#b6ccc7}.r .sb-item:focus-visible{outline:2px solid #acd7c5;outline-offset:2px}.r .sb-badge{background:#386457;color:#deebe5;border-radius:5px;font-size:9px;padding:3px 5px}.r .sb-footer{padding:18px 22px 21px;border-top:1px solid #ffffff0c}.r .sb-footer>button:not(.sb-sair){background:transparent!important;border:0!important;padding:0!important}.r .sb-footer>button:not(.sb-sair)>div:last-child{color:#829e94!important}.r .sb-sair{border:0;border-top:1px solid #ffffff15;border-radius:0;padding:15px 0 0;margin-top:10px;text-align:left;font-size:11px;font-weight:500;color:#a4bcb6}.r .sb-sair>span{justify-content:flex-start!important}.r .sb-sair:hover{color:#e9f6f2;background:transparent}@media(max-height:650px){.r .sb-logo{padding:16px 22px 14px}.r .sb-user{padding-top:10px;padding-bottom:10px}.r .sb-footer{padding:12px 22px 14px}}`;
export const BRAND = "#4FB3A9";
export const BRAND_DARK = "#1F4754";
export const SURFACE = "rgba(255,255,255,0.08)";
export const SURFACE_BORDER = "rgba(255,255,255,0.12)";
export const BUTTON_RESET = {
  border: "none",
  cursor: "pointer",
  fontFamily: "inherit",
};
export const CARD = {
  background: "#FFF",
  borderRadius: 14,
  boxShadow: "0 8px 24px rgba(0,0,0,.08)",
};
export const INPUT = {
  width: "100%",
  padding: "11px 12px",
  borderRadius: 10,
  border: "1.5px solid #D6E0E5",
  boxSizing: "border-box",
  fontFamily: "inherit",
  fontSize: 13,
  outline: "none",
};
export const LABEL = {
  display: "block",
  fontSize: 12,
  fontWeight: 700,
  color: "#415364",
  marginBottom: 6,
};
export const BTN_PRIMARY = {
  ...BUTTON_RESET,
  background: BRAND,
  color: "#FFF",
  borderRadius: 10,
  padding: "10px 16px",
  fontSize: 13,
  fontWeight: 800,
};
export const BTN_SECONDARY = {
  ...BUTTON_RESET,
  background: "transparent",
  color: "rgba(255,255,255,0.78)",
  border: "1px solid rgba(255,255,255,0.18)",
  borderRadius: 10,
  padding: "10px 16px",
  fontSize: 13,
  fontWeight: 700,
};
export const BTN_GHOST = {
  ...BUTTON_RESET,
  background: "#F6FAFB",
  color: "#415364",
  border: "1px solid #DBE5EA",
  borderRadius: 10,
  padding: "10px 14px",
  fontSize: 13,
  fontWeight: 700,
};
export const BLOCK_TYPES = [
  {
    tipo: "texto",
    label: "Texto",
    cor: "#7C3AED",
    fundo: "#F5F3FF",
    descricao: "Conteúdo formatado da aula.",
  },
  {
    tipo: "html",
    label: "HTML",
    cor: "#2563EB",
    fundo: "#EFF6FF",
    descricao: "Embed, iframe ou snippet visual.",
  },
  {
    tipo: "anexo",
    label: "Anexos",
    cor: "#B45309",
    fundo: "#FFF7ED",
    descricao: "PDF, imagem ou link complementar.",
  },
  {
    tipo: "video",
    label: "Vídeo",
    cor: "#059669",
    fundo: "#ECFDF5",
    descricao: "Vídeo hospedado ou embed de vídeo.",
  },
];
